// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addon.with-tooltip[data-v-a6632e6e]{position:relative;right:30px}", ""]);
// Exports
module.exports = exports;
